import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=5241eb14&scoped=true"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"
import style0 from "./AddressComponent.vue?vue&type=style&index=0&id=5241eb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241eb14",
  null
  
)

export default component.exports